module.exports = __webpack_public_path__ + "static/media/info_financiera.07b37e92.svg";